module.exports = "https://static-www.niulinkcloud.com/_next/static/media/mobileBg.ff84861f7796782bd6a850cc269f84e6.png";